import * as methods from '../methods';
import { Resource } from '../Resource';
import { rawHistoryParser1_1 } from './measurements';
const rootPath = 'oad/vpd';
export const fromRaw = {
    last: ({ value, timestamp }) => ({ value, timestamp }),
    history: rawHistoryParser1_1
};
const vpd = Resource((requesterBuilder) => {
    return {
        last: (query) => methods.get({
            requesterBuilder,
            rootPath: `${rootPath}/last`,
            fromRaw: fromRaw.last,
            params: {
                query: {
                    plot: query.plotId
                }
            }
        })(),
        history: (query) => methods.get({
            requesterBuilder,
            rootPath: `${rootPath}/history`,
            fromRaw: fromRaw.history,
            params: {
                query: {
                    plot: query.plotId,
                    source: query.source,
                    since: query.since,
                    before: query.before,
                    span: query.span
                }
            }
        })()
    };
});
export default vpd;
